
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden } from "../../reducers/uiReducer";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid, regular, light, thin, duotone, brands } from "@fortawesome/fontawesome-svg-core/import.macro";

import moment from 'moment';

const handleTabClick = (e: React.MouseEvent, tabName: string, dispatch: Dispatch, uiData: UIState) => {
    e.preventDefault();

    if (uiData.activeTab !== tabName) {
        dispatch(SET_activeTab(tabName));
    };
};

export const ProtectionTab: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                background: `radial-gradient(ellipse at 150.0% 150.0%, rgba(${uiData.schemeColor}, 0.9) 0%, rgba(20, 20, 20, 1) 80%)`,
                borderRadius: "2vh",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column",
                textAlign: "left",
                fontSize: "1.75vh",
                color: "gray",
                fontWeight: "500",
                padding: "2vh 2.5vh",
                gap: "2vh",
            }}
        >
            <div
                style={{
                    width: "100%",
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: "4vh",
                    //fontWeight: "bold",
                    fontFamily: 'Oswald',
                    fontWeight: "500",
                }}
            >
                Protection
            </div>
                
            Easily monitor your house locks and get notified when somebody tries to lockpick your house.


            <div 
                onClick={(e) => handleTabClick(e, "upgrades", dispatch, uiData)}
                style={{
                    border: `0.2vh solid rgb(${uiData.schemeColor})`,
                    backgroundColor: `rgba(${uiData.schemeColor}, 0.1)`,
                    padding: "1.25vh",
                    borderRadius: "1vh",
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: "1.25vh",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    cursor: "pointer",
                }}
            >
                Upgrade
            </div>
        </div>
    );
};


export const ParkingTab: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const garageData = hardmoneyData.propertyUpgrades.find((values, index) => {
        return (values.id == "garage")
    });

    if (!garageData) return;

    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                background: `radial-gradient(ellipse at 150.0% 150.0%, rgba(${uiData.schemeColor}, 0.9) 0%, rgba(20, 20, 20, 1) 80%)`,
                borderRadius: "2vh",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column",
                textAlign: "left",
                fontSize: "1.75vh",
                color: "gray",
                fontWeight: "500",
                padding: "1vh 2.5vh",
                gap: "2vh",
            }}
        >
            <div
                style={{
                    width: "100%",
                    color: `rgb(${uiData.schemeColor})`,
                    fontSize: "4vh",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    verticalAlign: "middle",
                    //backgroundColor: "red",
                }}
            >
                <FontAwesomeIcon 
                    icon={regular('garage')} 
                    style={{ 
                        width: '6vh', 
                        height: '6vh',
                        color: "rgba(255, 255, 255, 0.9)",
                    }}
                /> 
                {garageData.level}
            </div>

            <div
                style={{
                    width: "100%",
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: "4vh",
                    fontFamily: 'Oswald',
                    fontWeight: "500",
                }}
            >
                Parking Spots
            </div>
                
            This is how many parking spots you have outside of your house.

        </div>
    );
};

export const RoommateTab: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                background: `radial-gradient(ellipse at 150.0% 150.0%, rgba(${uiData.schemeColor}, 0.9) 0%, rgba(20, 20, 20, 1) 80%)`,
                borderRadius: "2vh",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column",
                textAlign: "left",
                fontSize: "1.75vh",
                color: "gray",
                fontWeight: "500",
                padding: "1vh 2.5vh",
                gap: "2vh",
            }}
        >
            <div
                style={{
                    width: "100%",
                    color: `rgb(${uiData.schemeColor})`,
                    fontSize: "4vh",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    verticalAlign: "middle",
                    //backgroundColor: "red",
                }}
            >
                <FontAwesomeIcon 
                    icon={regular('user-group')} 
                    style={{ 
                        width: '6vh', 
                        height: '6vh',
                        color: "rgba(255, 255, 255, 0.9)",
                    }}
                /> 
                {hardmoneyData.roommates.length - 1}
            </div>

            <div
                style={{
                    width: "100%",
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: "4vh",
                    fontFamily: 'Oswald',
                    fontWeight: "500",
                }}
            >
                Manage your roommates
            </div>
                
            <div 
                onClick={(e) => handleTabClick(e, "access", dispatch, uiData)}
                style={{
                    border: `0.2vh solid rgb(${uiData.schemeColor})`,
                    backgroundColor: `rgba(${uiData.schemeColor}, 0.1)`,
                    padding: "1.25vh",
                    borderRadius: "1vh",
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: "1.25vh",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    cursor: "pointer",
                }}
            >
                Manage
            </div>

        </div>
    );
};

export const MaintenanceTab: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const numericTimeInSeconds = moment(hardmoneyData.feeDueDate).unix();
    const formattedDate = moment.unix(numericTimeInSeconds).format("M/D/YYYY");

    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                background: `radial-gradient(ellipse at 150.0% 150.0%, rgba(${uiData.schemeColor}, 0.9) 0%, rgba(20, 20, 20, 1) 80%)`,
                borderRadius: "2vh",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column",
                textAlign: "left",
                fontSize: "1.75vh",
                color: "gray",
                fontWeight: "500",
                padding: "2vh 2.5vh",
                gap: "2vh",
            }}
        >
            <div
                style={{
                    width: "100%",
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: "4vh",
                    fontFamily: 'Oswald',
                    fontWeight: "500",
                }}
            >
                Maintenance Fees
            </div>
                
            Remember to pay your maintenance fees before {formattedDate}, the total is ${hardmoneyData.propertyFee.toLocaleString("en-US")}.


            <div 
                onClick={(e) => handleTabClick(e, "maintenance", dispatch, uiData)}
                style={{
                    border: `0.2vh solid rgb(${uiData.schemeColor})`,
                    backgroundColor: `rgba(${uiData.schemeColor}, 0.1)`,
                    padding: "1.25vh",
                    borderRadius: "1vh",
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: "1.25vh",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    cursor: "pointer",
                }}
            >
                Manage
            </div>
        </div>
    );
};
